import AssetsLeafletMap from "./AssetsLeafletMap.jsx";

export default AssetsLeafletMap;
